<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { paddingCss, isHidden } from '../canvasStyles';
import SelectionToolbar from '../SelectionToolbar.vue';
import CanvasTextLike from './CanvasTextLike.vue';
import CanvasImage from './CanvasImage.vue';
import CanvasSocial from './CanvasSocial.vue';
import CanvasProduct from './CanvasProduct.vue';
import CanvasButton from './CanvasButton.vue';
import CanvasDivider from './CanvasDivider.vue';
import CanvasSpacer from './CanvasSpacer.vue';
import CanvasHtml from './CanvasHtml.vue';

// Moldura de qualquer elemento: contorno ao passar o mouse, seleção, rótulo,
// barra de ações e o componente do tipo.

const props = defineProps({
  element: { type: Object, required: true },
  inner: { type: Number, required: true },
  desktopInner: { type: Number, default: null },
  bgValue: { type: String, default: null },
});
const ed = inject('emailEditor');
const { t } = useI18n();
const COMPONENTS = {
  heading: CanvasTextLike,
  text: CanvasTextLike,
  image: CanvasImage,
  logo: CanvasImage,
  button: CanvasButton,
  divider: CanvasDivider,
  spacer: CanvasSpacer,
  html: CanvasHtml,
  video: CanvasImage,
  social: CanvasSocial,
  product: CanvasProduct,
};
const selected = computed(() => ed.selectedId.value === props.element.id);
const highlighted = computed(
  () => !!ed.highlightIds?.value?.includes(props.element.id)
);
const outlineClass = computed(() => {
  if (selected.value) return 'z-10 outline outline-2 outline-n-brand';
  if (highlighted.value) return 'z-10 outline outline-2 outline-n-amber-9';
  return 'hover:outline hover:outline-n-brand/50';
});
const hidden = computed(() => isHidden(props.element.style, ed.device.value));
</script>

<template>
  <div
    :data-element="element.id"
    class="group/el relative outline-1 -outline-offset-1"
    :data-highlight="highlighted || undefined"
    :class="[outlineClass, hidden ? 'opacity-40' : '']"
    :style="{ padding: paddingCss(element.style?.padding) }"
    @click.stop="ed.select(element.id)"
  >
    <span
      class="pointer-events-none absolute left-0 top-0 z-10 hidden rounded-br bg-n-brand px-1.5 text-[10px] leading-4 text-white group-hover/el:block"
      :class="{ '!block': selected }"
      >{{ t(`EMAIL_TEMPLATES.EDITOR.ELEMENT.${element.type}`) }}</span
    >
    <SelectionToolbar
      v-if="selected"
      :node-id="element.id"
      kind="element"
      class="absolute right-0 top-0 z-20"
    />
    <component
      :is="COMPONENTS[element.type]"
      :element="element"
      :inner="inner"
      :desktop-inner="desktopInner"
      :bg-value="bgValue"
      :selected="selected"
    />
  </div>
</template>
